module.exports = __webpack_public_path__ + "static/o-t-2-21023537687d4ac48dce80ee6915b657.jpg";